import { useEffect, useState } from "react";
import { api } from "../api";
import type { SettlementBatch, SettlementBatchSummary } from "../types";
import { SettlementSmsModal } from "./SettlementSmsModal";

export function PayrollSmsLoader({ summary, refresh, onClose, onCloseAll, notify }: { summary: SettlementBatchSummary; refresh: () => Promise<void>; onClose: () => void; onCloseAll?: () => void; notify: (text: string, error?: boolean) => void }) {
  const [batch, setBatch] = useState<SettlementBatch | null>(null);
  useEffect(() => {
    let active = true;
    void api.getSettlementBatch(summary.id).then(detail => {
      if (active) setBatch(detail);
    }).catch(cause => {
      if (!active) return;
      notify(cause instanceof Error ? cause.message : "문자 정보를 불러오지 못했습니다.", true);
      onClose();
    });
    return () => { active = false; };
  }, [summary.id]);
  return batch ? <SettlementSmsModal batch={batch} refresh={refresh} onClose={onClose} onCloseAll={onCloseAll} onSaved={notify} /> : null;
}
